const getImage = (filename) => {
  return require(`../img/saleProducts/${filename}`);
};

export const saleProducts = [
    {
        id: "sie-00000001",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1016 9A. Disponible en 24V, 110V y 380V - Siemens",
        image: getImage("SIE-00000001.jpg"),
        price: 42000,
    },
    {
        id: "sie-00000002",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1017 12A. Disponible en 24V, 110V y 220V - Siemens",
        image: getImage("SIE-00000001.jpg"),
        price: 45000,
    },
    {
        id: "sie-00000003",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1023 9A. Disponible en 24V, 110V y 220V - Siemens",
        image: getImage("SIE-00000002.jpg"),
        price: 45500,
    },
    {
        id: "sie-00000004",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1024 12A. Disponible en 24V, 110V y 220V - Siemens",
        image: getImage("SIE-00000002.jpg"),
        price: 54000,
    },
    {
        id: "sie-00000005",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1025 17A. Disponible en 24V - Siemens",
        image: getImage("SIE-00000002.jpg"),
        price: 54000,
    },
    {
        id: "sie-00000006",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1034 32A. Disponible en 24V y 110V - Siemens",
        image: getImage("SIE-00000003.jpg"),
        price: 104000,
    },
    {
        id: "sie-00000007",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1035 40A. Disponible en 24V, 110V y 380V - Siemens",
        image: getImage("SIE-00000003.jpg"),
        price: 186000,
    },
    {
        id: "sie-00000008",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1036 50A. Disponible en 24V - Siemens",
        image: getImage("SIE-00000003.jpg"),
        price: 244000,
    },
    {
        id: "sie-00000009",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1044 65A. Disponible en 24V - Siemens",
        image: getImage("SIE-00000004.jpg"),
        price: 365000,
    },
    {
        id: "sie-00000010",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3RT 1046 80A. Disponible en 110V y 380V - Siemens",
        image: getImage("SIE-00000004.jpg"),
        price: 444000,
    },
    {
        id: "sie-00000011",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3TF44 65A. Disponible en 110V - Siemens",
        image: getImage("SIE-00000006.jpg"),
        price: 365000,
    },
    {
        id: "sie-00000012",
        brand: "Siemens",
        category: "Contactores",
        description: "Contactor 3TF44 90A. Disponible en 220V - Siemens",
        image: getImage("SIE-00000007.jpg"),
        price: 444000,
    },
    {
        id: "sie-00000013",
        brand: "Siemens",
        category: "Relevos Térmicos",
        description: "Relevo Térmico 3RU11 16 - Disponible de 1.1A a 12A - Siemens",
        image: getImage("SIE-00000005.jpg"),
        price: 58400,
    },
    {
        id: "sie-00000014",
        brand: "Siemens",
        category: "Relevos Térmicos",
        description: "Relevo Térmico 3RU11 26 - Disponible de 1.8A a 10A - Siemens",
        image: getImage("SIE-00000005.jpg"),
        price: 118500,
    },
    {
        id: "sie-00000015",
        brand: "Siemens",
        category: "Relevos Térmicos",
        description: "Relevo Térmico 3RU11 36 - Disponible de 14A a 50A - Siemens",
        image: getImage("SIE-00000005.jpg"),
        price: 180000,
    },
    {
        id: "mge-00000001",
        brand: "Schneider Electric",
        category: "Interruptores",
        description: "Disyuntor Diferencial Tetrapolar 25a 30ma Domae Schneider",
        image: getImage("MGE-00000001.jpg"),
        price: 97211,
    },
    {
        id: "mge-00000002",
        brand: "Schneider Electric",
        category: "Interruptores",
        description: "Llave Térmica Tetrapolar 6a 3ka Curva C Domae Schneider",
        image: getImage("MGE-00000002.jpg"),
        price: 43052,
    },    {
        id: "mge-00000003",
        brand: "Schneider Electric",
        category: "Interruptores",
        description: "Llave Térmica Unipolar 50a 60ka Curva C Schneider",
        image: getImage("MGE-00000003.jpg"),
        price: 35120,
    },
    {
        id: "mge-00000004",
        brand: "Merlin Gerin",
        category: "Interruptores",
        description: "Llave Térmica Tripolar 40a Curva C Merlin Gerin",
        image: getImage("MGE-00000004.jpg"),
        price: 29785,
    },
    {
        id: "flu-00000001",
        brand: "Fluke",
        category: "Instrumentos de medición",
        description: "Multímetro Digital 113 Fluke",
        image: getImage("FLU-00000001.jpg"),
        price: 589400,
    },
    {
        id: "flu-00000002",
        brand: "Fluke",
        category: "Instrumentos de medición",
        description: "Comprobador T5-1000 Fluke",
        image: getImage("FLU-00000002.jpg"),
        price: 457000,
    },
    {
        id: "flu-00000003",
        brand: "Fluke",
        category: "Instrumentos de medición",
        description: "Multímetro Digital 114 Fluke",
        image: getImage("FLU-00000003.jpg"),
        price: 619700,
    },
    {
        id: "flu-00000004",
        brand: "Fluke",
        category: "Instrumentos de medición",
        description: "Comprobador T90 Fluke",
        image: getImage("FLU-00000004.jpg"),
        price: 299400,
    },
    {
        id: "flu-00000005",
        brand: "Amprobe",
        category: "Instrumentos de medición",
        description: "Megohmetro Digital Amb-25 Amprobe",
        image: getImage("FLU-00000005.jpg"),
        price: 1614500,
    },
    {
        id: "flu-00000006",
        brand: "Amprobe",
        category: "Instrumentos de medición",
        description: "Capacímetro con ajuste de cero CR50A Amprobe",
        image: getImage("FLU-00000006.jpg"),
        price: 425000,
    },
    {
        id: "flu-00000007",
        brand: "Amprobe",
        category: "Instrumentos de medición",
        description: "Secuencímetro con indicador de fases y rotación de motores PRM-4 Amprobe",
        image: getImage("FLU-00000007.jpg"),
        price: 689100,
    },
    {
        id: "lgs-00000001",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Taladro Rotomartillo 800w Sds Plus D25133k DeWalt",
        image: getImage("LGS-00000001.jpg"),
        price: 229500,
    },
        {
        id: "lgs-00000002",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Cortadora de concreto 1400w DW862B DeWalt",
        image: getImage("LGS-00000002.jpg"),
        price: 278000,
    },
        {
        id: "lgs-00000003",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Amoladora angular Pitbull 9'' 2200w DWE490 DeWalt",
        image: getImage("LGS-00000003.jpg"),
        price: 358400,
    },
        {
        id: "lgs-00000004",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Amoladora angular Pitbull 7'' 2200w DWE491 DeWalt",
        image: getImage("LGS-00000004.jpg"),
        price: 258400,
    },
        {
        id: "lgs-00000005",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Amoladora angular 800w DWE4020 DeWalt",
        image: getImage("LGS-00000005.jpg"),
        price: 162600,
    },
        {
        id: "lgs-00000006",
        brand: "DeWalt",
        category: "Herramientas",
        description: "Amoladora angular 1200w DWE4214 DeWalt",
        image: getImage("LGS-00000006.jpg"),
        price: 200700,
    },
        {
        id: "lgs-00000007",
        brand: "Stanley",
        category: "Herramientas",
        description: "Kit Rotomartillo Compacto + Maletín + Mechas STHR1232K Stanley",
        image: getImage("LGS-00000007.jpg"),
        price: 263700,
    },
        {
        id: "lgs-00000008",
        brand: "Stanley",
        category: "Herramientas",
        description: "Taladro Percutor 800w 13mm STDH8013 Stanley",
        image: getImage("LGS-00000008.jpg"),
        price: 110000,
    },
    {
        id: "lgs-00000009",
        brand: "Stanley",
        category: "Herramientas",
        description: "Taladro Inalámbrico 10mm SCD12S2K Stanley",
        image: getImage("LGS-00000009.jpg"),
        price: 293700,
    },
];